export default{
    activeModalData: {
        title: '',
        height: '',
        name: false
    }
}